import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import {
  IglooStaffDevices,
  normalizeIglooStaffDevices,
  RawIglooStaffDevices,
} from './normalize-igloo-staff-devices'

// `userId` is the global User id (user.id), NOT the role-table row id. Confirmed live on staging:
// GET /igloowork/staff/3867/devices -> 200 with the door list, while the same staff member's
// record id (21) -> 404 "Staff member not found". The backend's own param naming is the tell —
// the resident route takes :clientId, this one takes :userId.
type GetIglooStaffDevicesRequest = { userId: string }

export const getIglooStaffDevicesQueryKey = (data: GetIglooStaffDevicesRequest) => [
  'useGetIglooStaffDevices',
  data,
]

const getIglooStaffDevices = async (
  data: GetIglooStaffDevicesRequest,
): Promise<IglooStaffDevices> => {
  const response = await authAPI.get<RawIglooStaffDevices>(
    `/igloowork/staff/${data.userId}/devices`,
  )
  return normalizeIglooStaffDevices(response.data)
}

export const useGetIglooStaffDevices = (data: GetIglooStaffDevicesRequest, enabled = true) =>
  useQuery({
    enabled: enabled && Boolean(data.userId),
    queryFn: () => getIglooStaffDevices(data),
    queryKey: getIglooStaffDevicesQueryKey(data),
  })

export const useInvalidateIglooStaffDevices = (userId: string) => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: getIglooStaffDevicesQueryKey({ userId }) })
}
